import { Component, ChangeDetectionStrategy, EventEmitter, OnInit, Output, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreditCardValidator } from 'ngx-credit-cards';
import { filter } from 'rxjs/operators';
import { requiredValidator } from '../../validators';
import { markAsTouched } from '../../utils';

export interface CreditCardDetails {
  number: number;
  expiryMonth: number;
  expiryYear: number;
  cvc: number;
  name: string;
}

@Component({
  selector: 'app-credit-card-form',
  templateUrl: 'credit-card-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditCardFormComponent implements OnInit, OnChanges {
  form = new FormGroup({
    number: new FormControl(null, [requiredValidator(), CreditCardValidator.validateCardNumber]),
    expiryMonth: new FormControl(null, [requiredValidator(), Validators.pattern(/^\d{2}$/)]),
    expiryYear: new FormControl(null, [requiredValidator(), Validators.pattern(/^\d{4}$/)]),
    cvc: new FormControl(null, [requiredValidator(), CreditCardValidator.validateCardCvc]),
    name: new FormControl(null, requiredValidator()),
  });

  @Input() submitted: boolean = false;
  @Output() onChange = new EventEmitter();

  ngOnInit() {
    this.form
      .valueChanges
      .pipe(filter(() => this.form.valid))
      .subscribe(value => {
        markAsTouched(this.form);
        this.onChange.emit(value);
      });
  }

  ngOnChanges() {
    if (this.submitted) {
      markAsTouched(this.form);
    }
  }

  get number() {
    return this.form.get('number');
  }

  get expiryMonth() {
    return this.form.get('expiryMonth');
  }

  get expiryYear() {
    return this.form.get('expiryYear');
  }

  get cvc() {
    return this.form.get('cvc');
  }

  get name() {
    return this.form.get('name');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/payments/credit-card-form.component.ts